<div *ngIf="show" style="padding: 50px" class="text-center">
  <h2 *ngIf="!message" class="text-center" [translate]="'SHARED.empty_dataset'"
      [translateParams]="{dataset: setName ? setName : 'data'}">
  </h2>
  <h2 *ngIf="message">{{ message }}</h2>
</div>
